export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");

        function closePopup() {

            $(".popup").removeClass("active");
            mainWrap.removeClass("popup-open");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $target = $this.attr("href");

            if ($this.attr('data-post-id')) {
                let data = {
                    'action': 'info_partner',
                    'post_id': $this.attr('data-post-id')
                };

                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                    },
                    success: function (response) {
                        if (response) {
                            $('#popup-partner .popup-ajax-holder').html(response);
                        }
                    },
                    complete: function () {
                        $($target).addClass("active").fadeIn(300);
                        mainWrap.addClass("popup-open");
                    }
                });
            } else {
                $($target).addClass("active").fadeIn(300);
                mainWrap.addClass("popup-open");
            }


        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });


        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length) {
                closePopup.call(this);
            }
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js